<skl-dialog-content-ins [isReady]="viewModel.isFormReady">
	<skl-dialog-header-ins
		[title]="'scenes.configuration.shared.document-configuration.dialog.title' | translate"
		id="order-kind-dialog-header"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		<skl-form-container>
			@if (viewModel.isFormReady) {
				<div
					class="grid"
					[sklValidationSource]="viewValidation"
					[skl-focus-by]>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.document-configuration.dialog.form.name.label' | translate">
							<ins-input
								id="order-kind-dialog-document-name"
								[(ngModel)]="viewModel.documentName"
								[placeholder]="'scenes.configuration.shared.document-configuration.dialog.form.name.placeholder' | translate"
								[sklValidate]="getValidationKey('name')">
							</ins-input>
						</ins-form-field>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.order-kind.dialog.form.default-document.label' | translate">
							<ins-select
								display-text="label"
								id="order-kind-dialog-default-document-to-issue"
								[converter]="viewModel.documentKindConverter"
								[(ngModel)]="viewModel.bo.model.defaultDocumentToIssue">
								@for (item of viewModel.documentKinds; track item) {
									<ins-option
										[value]="item">
										{{item.label}}
									</ins-option>
								}
							</ins-select>
						</ins-form-field>
					</div>
					@if (viewModel.vatRateVisible) {
						<div class="col-1">
							<ins-form-field
								[label]="'scenes.configuration.shared.order-kind.dialog.form.default-vat-rate.label' | translate">
								<ins-select
									id="order-kind-dialog-default-vat-rate"
									display-text="name"
									[converter]="viewModel.vatRateValueConverter"
									[(ngModel)]="viewModel.bo.model.defaultVatRateId">
									@for (item of viewModel.vatRates; track item) {
										<ins-option
											[value]="item">
											{{ item.name }}
										</ins-option>
									}
								</ins-select>
							</ins-form-field>
						</div>
					}
				</div>
			}
		</skl-form-container>
	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			id="order-kind-dialog-cancel-button"
			(click)="onCancel()">
			{{'scenes.configuration.shared.base.dialog.buttons.cancel' | translate}}
		</skl-button>
		<skl-button
			id="order-kind-dialog-save-button"
			typeName="accent"
			[spinner]="viewModel.isSaving"
			(click)="onConfirmAsync()">
			{{'scenes.configuration.shared.base.dialog.buttons.save' | translate}}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>